import * as React from 'react';

import cx from 'classnames';

import s from './StaggeredList.module.css';

type TProps = {
  id: string;
  className?: string;
  items: any[];
  renderItem: (item: any) => React.ReactNode;
};

export const StaggeredList = ({ id, className, items, renderItem }: TProps) => (
  <ul id={id} className={cx(s.listContainer, className)}>
    {items.map((item, idx) => {
      return <li key={`${id}-${idx}`}>{renderItem(item)}</li>;
    })}
  </ul>
);
